<!-- src/views/BranchesView.vue -->
<template>
    <div class="container">

        <div>
            <button type="button" class="btn btn-primary btn-sm m-1" @click="ShowAddBranchModal()">
            Add Branch
            </button>
        </div>

        <span v-if="isDataFetched" class="d-flex justify-content-center">
            <div class="spinner-border text-primary">
                <span class="visually-hidden"></span>
            </div>
             Loading...
        </span>

        <div class="row m-2">
            <table class="table text-left bg-light text-dark table-hover col-12">
                <thead>
                    <tr class="h4 col-12">
                        <td>Name</td>
                        <td>City</td>
                        <td>Phone</td>
                        <td>Edit</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="branch in branches" v-bind:key="branch.branchId" @click="showBranchModal(branch)" class="col-12">
                        <td @click="ShowBranchDetailModal(branch)">{{branch.branchName}}</td>
                        <td @click="ShowBranchDetailModal(branch)">{{branch.cityName || "-"}}</td>
                        <td @click="ShowBranchDetailModal(branch)">{{branch.phone || "-"}}</td>
                        <td @click="ShowUpdateModal(branch)">Edit</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <button type="button" class="btn btn-primary collapse" id="branchDetailModalButton" data-bs-toggle="modal" data-bs-target="#branchDetailModal">
        Launch branchDetailModal
        </button>

        <div class="modal" id="branchDetailModal" tabindex="999999">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-align-center text-primary fw-bold" id="branchDetailModalLabel" v-if="!isNewBranchToAdd">Detail for Branch with Branch-Id = {{selectedBranch.branchId}}</h4>
                        <h4 class="modal-title text-align-center text-primary fw-bold" id="branchDetailModalLabel" v-if="isNewBranchToAdd">Enter New Branch Information</h4>

                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">

                        <div class="row p-2 m-2 modal-body text-left">
                            <div class="row mb-2">
                                <span class="text-primary col-3">Name </span>
                                <span class="text-primary col-9" v-if="!isEntryMode">{{selectedBranch.branchName}}</span>
                                <input type="text" v-if="isEntryMode" class="text-danger col-9" v-model="selectedBranch.branchName" placeholder="Enter Branch Name ">
                            </div>
                            <div class="row mb-2">
                                <span class="text-primary col-3">Address </span>
                                <span class="text-primary col-9" v-if="!isEntryMode">{{selectedBranch.address || "-"}}</span>
                                <input type="text" v-if="isEntryMode" class="text-danger col-9" v-model="selectedBranch.address" placeholder="Enter Address ">
                            </div>
                            <div class="row mb-2">
                                <span class="text-primary col-3">City </span>
                                <span class="text-primary col-9" v-if="!isEntryMode">{{selectedBranch.cityName || "-"}}</span>
                                <select v-if="isEntryMode" class="col-9" v-model="selectedBranch.cityId">
                                    <option :value="null">-- None --</option>
                                    <option v-for="city in cities" :key="city.id" :value="city.id">{{city.name}}</option>
                                </select>
                            </div>
                            <div class="row mb-2">
                                <span class="text-primary col-3">Phone </span>
                                <span class="text-primary col-9" v-if="!isEntryMode">{{selectedBranch.phone || "-"}}</span>
                                <input type="text" v-if="isEntryMode" class="text-danger col-9" v-model="selectedBranch.phone" placeholder="Enter Phone ">
                            </div>
                            <div class="row" v-if="!isNewBranchToAdd">
                                <span class="text-primary col-3">Active </span>
                                <span class="text-primary col-9" v-if="!isEntryMode">{{selectedBranch.isActive ? "Yes" : "No"}}</span>
                                <input type="checkbox" v-if="isEntryMode" class="col-9" v-model="selectedBranch.isActive">
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        <button type="button" v-if="!isNewBranchToAdd" @click="DeleteBranch()" class="btn btn-danger">Delete Branch</button>
                        <button type="button" v-if="!isNewBranchToAdd" @click="UpdateBranch()" class="btn btn-secondary" data-bs-dismiss="modal">Update Branch</button>
                        <button type="button" v-if="isNewBranchToAdd" @click="AddBranch()" class="btn btn-secondary" data-bs-dismiss="modal">Add Branch</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import { toRaw } from 'vue';

export default({
name:'BranchesView',
props:{
    baseUrl:String
},
data() {
    return {
        branches:[],
        cities:[],
        isDataFetched:false,
        selectedBranch:{},
        isNewBranchToAdd:false,
        isEntryMode:true,
        isModalAlreadyOpened:false
    }
},
methods:{
    loadCitiesFromLookupData(){
        const cachedData = localStorage.getItem("lookupData");
        if (!cachedData) return;
        const data = JSON.parse(cachedData);
        this.cities = data.cities || [];
    },
    getBranchesList(){
        this.isDataFetched = true;
        let branchesRequestUrl = this.baseUrl + "Branches/GetAll";
        let branchesRequestOptions = {
            method:"GET",
            headers:{
              "Authorization":"Bearer " + localStorage.token,
              "Content-Type" : "application/json"
            },
          };

          fetch(branchesRequestUrl, branchesRequestOptions)
          .then(response =>{
            return response.json();
          })
          .then(res =>{
            this.branches = res.branches;
            this.isDataFetched = false;
          })
          .catch(error=>{
            error = null;
            console.log("error encountered", error);
            this.isDataFetched = false;
          });
    },
    AddBranch(){
        let addBranchRequestUrl = this.baseUrl + "Branches/Add";
        let addBranchRequestOptions = {
            method:"POST",
            headers:{
                "Authorization":`Bearer ${localStorage.token}`,
                "Content-Type":"application/json"
            },
            body:JSON.stringify(
                {
                    "branchId" : 0,
                    "branchName": this.selectedBranch.branchName,
                    "address": this.selectedBranch.address,
                    "cityId": this.selectedBranch.cityId,
                    "phone": this.selectedBranch.phone,
                    "isActive": true
                }
            )
        };

        fetch(addBranchRequestUrl, addBranchRequestOptions)
        .then(async response=>{
            const result = await response.json();

            if(response.ok){
                alert("Branch added successfully!");
                await this.getBranchesList();
            }
            else{
                alert("Failed to add branch. Please try again.");
                console.error("Add error:", result);
            }
        })
        .catch(error=>{
            console.error("Add failed:", error);
            alert("An error occurred while adding the branch.");
        });
    },
    UpdateBranch(){
        let updateBranchRequestUrl = this.baseUrl + "Branches/Update";
        let updateBranchRequestOptions = {
            method:"POST",
            headers:{
                "Authorization":`Bearer ${localStorage.token}`,
                "Content-Type":"application/json"
            },
            body:JSON.stringify(
                {
                    "branchId" : this.selectedBranch.branchId,
                    "branchName": this.selectedBranch.branchName,
                    "address": this.selectedBranch.address,
                    "cityId": this.selectedBranch.cityId,
                    "phone": this.selectedBranch.phone,
                    "isActive": this.selectedBranch.isActive
                }
            )
        };

        fetch(updateBranchRequestUrl, updateBranchRequestOptions)
        .then(async response=>{
            const result = await response.json();

            if(response.ok){
                alert("Branch updated successfully!");
                await this.getBranchesList();
            }
            else{
                alert("Failed to update branch. Please try again.");
                console.error("Update error:", result);
            }
        })
        .catch(error=>{
            console.error("Update failed:", error);
            alert("An error occurred while updating the branch.");
        });
    },
    DeleteBranch(){
        if(!confirm("Delete branch '" + this.selectedBranch.branchName + "'? Officer Groups assigned to it will be unassigned, not deleted.")){
            return;
        }

        let deleteBranchRequestUrl = this.baseUrl + "Branches/Delete";
        let deleteBranchRequestOptions = {
            method:"POST",
            headers:{
                "Authorization":`Bearer ${localStorage.token}`,
                "Content-Type":"application/json"
            },
            body:JSON.stringify(
                {
                    "Id": this.selectedBranch.branchId
                }
            )
        };

        fetch(deleteBranchRequestUrl, deleteBranchRequestOptions)
        .then(async response=>{
            const result = await response.json();

            if(response.ok){
                alert("Branch deleted successfully!");
                document.getElementById("branchDetailModalButton").click();
                await this.getBranchesList();
            }
            else{
                alert(result.details || "Failed to delete branch. Please try again.");
                console.error("Delete error:", result);
            }
        })
        .catch(error=>{
            console.error("Delete failed:", error);
            alert("An error occurred while deleting the branch.");
        });
    },
    ShowAddBranchModal(){
        this.isEntryMode = true;
        this.isNewBranchToAdd = true;
        this.selectedBranch = {
            branchId : 0,
            branchName : "",
            address: "",
            cityId: null,
            phone: "",
            isActive: true
        };
        document.getElementById("branchDetailModalButton").click();
    },
    ShowBranchDetailModal(branch){
        this.isNewBranchToAdd = false;
        this.isEntryMode = false;

        this.selectedBranch = { ...toRaw(branch) };

        document.getElementById("branchDetailModalButton").click();
    },
    showBranchModal(branch){
        if(this.isModalAlreadyOpened == false)
        {
            this.selectedBranch = { ...toRaw(branch) };
            document.getElementById("branchDetailModalButton").click();
        }
    },
    ShowUpdateModal(branch){
        this.isNewBranchToAdd = false;
        this.isEntryMode = true;

        this.selectedBranch = { ...toRaw(branch) };

        document.getElementById("branchDetailModalButton").click();
    }
},
mounted(){
    this.loadCitiesFromLookupData();
    this.getBranchesList();

    const branchDetailModalEl = document.getElementById('branchDetailModal')
    branchDetailModalEl.addEventListener('shown.bs.modal', event => {
        this.isModalAlreadyOpened = true;
    });
    branchDetailModalEl.addEventListener('hidden.bs.modal', async event => {
        this.isModalAlreadyOpened = false;
        await this.getBranchesList();
    });
},

})
</script>
<style>
</style>
